<template lang='pug'>
div(style='padding-left: 10px')
  el-row(:gutter='$rowGutter')

    el-col(:span='6')
      h3 {{backendData.account_name}}
      div
        i.mat-icon person
        |  {{contact_name}}
      div
        i.mat-icon email
        |  {{backendData.email || "Unknown"}}
      div
        i.mat-icon phone
        |  {{backendData.contact_phone_number || "Unknown"}}

      div(style='margin-top: 1rem')
        i.mat-icon home
        |  {{backendData.address_line_1 || "Unknown"}}
      div {{backendData.address_line_2}}
      div(v-if='backendData.city != null') {{backendData.city}}, {{backendData.state}} {{backendData.zip_code}}

    el-col(:span='6', v-loading='customer == null')
      h3 Billing info
      div(v-if='customer != null')
        div
          el-checkbox(v-model='customer.allow_offline_payments', @change='trackChange')
            | Allow post-paid billing
        div
          el-checkbox(v-model='customer.tax_exempt', @change='trackChange')
            | Tax exempt

    el-col(:span='12', v-loading='customer == null')
      h3 Staff notes
      div(v-if='customer != null')
        el-input(
          type='textarea' v-model='customer.staff_notes' max='250',
          :rows='4', @focus='trackChange'
        )

  el-row.buttons-section(:gutter='$rowGutter')
    el-col(:span='8', :offset='16', style='text-align: right')
      el-button(
        type='danger', @click='onDelete', :loading='deleting',
      ) Archive customer
      el-button(
        type='primary', @click='onSubmit', :loading='submitting',
        :disabled='!dataChanged'
      ) Save
</template>

<script>

  function data(){
    return {
      customer: null,
      submitting: false,
      dataChanged: false,
      deleting: false
    }
  }

  function trackChange(){
    this.dataChanged = true
  }

  function getCustomer(){
    return this.$simplecater.get(`/customers/${this.backendData.id}`).then((r)=> {
      this.customer = r.data.data
    })
  }

  function created(){
    this.getCustomer()
  }

  function onSubmit(){
    this.submitting = true
    const target = `/customers/${this.backendData.id}`
    this.$simplecater.put(target,this.customer).then((r)=>{
      this.submitting = false
      this.$message("The customer has been saved")
    }).catch( ( err ) => {
      this.submitting = false
      let errorString = ( err )? (': ' + JSON.stringify(err)) : ''
      this.$message.error("Saving failed" + errorString)
    })
  }

  function onDelete(){
    const title = "Delete Customer"
    const msg = "The customer will be deleted. Continue?"
    this.$confirm(msg, title, {
      confirmButtonText: 'Yes, delete',
      cancelButtonText: 'Cancel',
      type: 'warning'
    }).then(() => {
      console.log("DELETING CUSTOMER")
      this.deleteCustomer(this.customer.id)
    }).catch(() => { })
  }

  const computed = {
    contact_name: function(){
      const cust = this.backendData
      if (cust.contact_salutation == null) return "Unknown"
      return `${cust.contact_salutation} ${cust.contact_first_name} ${cust.contact_last_name}`
    }
  }

  function deleteCustomer ( id ) {
    const target = `/customers/${id}`
    this.deleting = true
    console.log("NETWORK DELETING CUSTOMER", id)
    this.$simplecater.delete(target).then(r => {
      this.$message("The customer has been deleted")
      this.deleting = false
      this.$emit('deleted')
    }).catch(()=>{
      this.$message.error("Deleting the customer failed")
      this.deleting = false
    })
  }

  const watch = {
    'backendData' () {
      this.getCustomer()
    }
  }

  const props = {
    backendData: { required: true}
  }

  const components = { }

  const methods = {
    getCustomer, onSubmit, trackChange, onDelete, deleteCustomer
  }

  export default { props, methods, components, data, created, computed }
</script>



// WEBPACK FOOTER //
// src/staff/blocks/Customer.vue